export default __webpack_public_path__ + "static/media/insurance_background.9b89a0cc.jpg";